import React from 'react';
import { X, Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

/**
 * Generic "feature locked" upgrade dialog.
 * Shown when a user taps a card/link that is disabled for their current plan.
 * Same visual style as AIChatbotUpgradeDialog.
 */
const FeatureLockedDialog = ({ isOpen, onClose, featureName = 'This feature' }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleUpgrade = () => {
    onClose();
    navigate('/portal/subscription');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[9999] p-4">
      <div className="bg-[#050125] rounded-3xl border border-white/20 max-w-md w-full relative overflow-hidden">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-white hover:text-gray-400 bg-transparent border-none p-1 z-10 transition-colors"
        >
          <X size={20} />
        </button>

        <div className="p-8 flex flex-col items-center">
          <div className="w-16 h-16 mb-6 flex items-center justify-center">
            <Lock className="text-[#C99F4A] w-12 h-12" />
          </div>

          <h2 className="text-2xl font-bold text-white text-center mb-4">
            {featureName}
          </h2>

          <p className="text-white/70 text-center mb-6 text-sm px-2">
            This feature is not included in your current plan.
            <br /><br />
            Upgrade your subscription to unlock it.
          </p>

          <button
            onClick={handleUpgrade}
            className="w-32 h-12 bg-[#C99F4A] hover:bg-[#D19B15] text-white rounded-xl font-semibold text-base transition-colors"
          >
            Upgrade
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeatureLockedDialog;
